module.exports = __webpack_public_path__ + "media/images/landkit/photos/photo-6-93f36d2d140f877e8255b95036e940ab.jpg";